import SuppliersReportResult from './ResultPage';

export default SuppliersReportResult;
